import { ALIGN, VALIGN } from '_pixiSrc/globals';
import { MOBILE } from '_pixiSrc/layout/features';
import Sprite from '_pixiSrc/display/Sprite';

import I18 from '_pixiSrc/I18';
import Static from '../libraries/Static';
import GameData from '../ui/GameData';
import DynamicData from './DynamicData';
import { GAME_DATA_KEY } from '../Constants';

// object of values and options for text output
let data;

// Object with links to all elements that contain text
let links = [];

// used for styling numbers in text panel
const styleForNumbers = {
    fill: 0xfcd781,
    valign: VALIGN.MIDDLE,
    align: ALIGN.LEFT,
    weight: 'bold',
    size: 22,
};

// used for styling text in text panel
const styleForText = {
    fill: 0xFFDB9C,
    valign: VALIGN.MIDDLE,
    align: ALIGN.LEFT,
    weight: 'bold',
    size: 18,
};

const textPanelMaxSize = (MOBILE) ? 250 : 428; // maximum width of text panels displaying message
const maxScaleTextPanel = 1; // maximum scale of text panels displaying message
const minScaleTextPanel = 0.7; // minimum scale of text panels displaying message
let spriteTexts = []; // store text sprites

/**
* @class TextPanel
* @memberOf module:ui
* @classdesc TextPanel class manage text data in panel at bottom which
displays current win/lose status total wallet amount etc
*/
class TextPanel {
    // initiating an object with given text phrases
    static _init() {
        data = {
            clear: () => '',
            clickSpin: () => I18.f('tpNoWin'),
            // init: () => I18.f('tpInit'),
            totalWin: winSum => I18.f('tpTotalWin', winSum),
            expandingWin: winSum => I18.f('tpExpandingWin', winSum),
            // lineWin: (winSum, lineNumber) => I18.f('tpLineWin', lineNumber, winSum),
            // clickSpin: (winSum) => (winSum) ? I18.f('tpClickSpin', winSum) : I18.f('tpNoWin'),
            // totalWin: winSum => FEATURES.MOBILE ? I18.f('tpWin', winSum) : I18.f('tpTotalWin', winSum),
            // expandingWin: winSum => FEATURES.MOBILE ? I18.f('tpExpWin', winSum) : I18.f('tpExpandingWin', winSum),
            // lineWin: winSum => I18.f('tpLineWin', winSum),
            // clickSpin: (winSum) => (winSum) ? (FEATURES.MOBILE ? I18.f('tpLastWin', winSum) : I18.f('tpClickSpin', winSum)) : I18.f('tpNoWin'),
            // triggerBG: () => I18.f('tpTriggerBG'),
            duringSpecialSpin: count => I18.f('tpDuringSpecialSpins', count || DynamicData.getData(GAME_DATA_KEY.SPECIALSPIN).currentFreeSpin, DynamicData.getData(GAME_DATA_KEY.SPECIALSPIN).freeSpins),
            triggerFG: () => I18.f('tpTriggerFG'),
            // triggerGS: () => I18.f('tpTriggerGS'),
            // startDialogue: (time = 5) => GameData.getProperty('isAutospin') ? I18.f('tpFGBGSGStartDialogue1', time) : I18.f('tpFGBGSGStartDialogue2'),
            duringFG: (...rest) => I18.f('tpDuringFG', DynamicData.getData('freeSpinData').currentFreeSpin, DynamicData.getData('freeSpinData').freeSpins),
            // duringGS: (...rest) => I18.f('tpDuringGS', ...rest),
            FGComplete: () => I18.f('tpFGComplete'),
            // GSComplete: () => I18.f('tpGSComplete'),
            // BGComplete: () => I18.f('tpBGComplete'),
            // coverDialogueAppear: () => I18.f('tpCoverDialogueAppear'),
            // gambleGameEnd: () => I18.f('tpGambleGameEnd'),
            // finalCountdown: (value) => I18.f('tpStartIn', value),
            // tpAmount: (value) => (value) ? I18.f('tpAmount', value) : I18.f('tpNoWin')
        };

        if (MOBILE) {
            Object.assign(data, {
                totalWin: winSum => I18.f('tpTotalWin', winSum),
                expandingWin: winSum => I18.f('tpExpandingWin', winSum),
                // lineWin: (winSum, lineNumber) => I18.f('tpMobileLineWin', lineNumber, winSum),
                clickSpin: () => I18.f('tpNoWin'),
                // duringFG: (...rest) => I18.f('tpMobileDuringFG', DynamicData.getData('freeSpinData').currentFreeSpin, DynamicData.getData('freeSpinData').freeSpins),
            });
        }
    }

    // external method of applying text to an element
    static writeText(parent, font, x, y) {
        if (!data) {
            this._init();
        }
        links = [];
        this.font = font;
        this.xPosition = x;
        this.yPosition = y;
        if (this.currentKey === undefined) {
            this.currentKey = 'clear';
            this.currentRestParams = [];
        }
        const textSprite = parent.addChild(new Sprite());

        links.push(textSprite);

        this.singleLineHeight = 19;

        TextPanel.sendMessage(this.currentKey, ...this.currentRestParams);

        return textSprite;
    }

    // line change
    static sendMessage(key, ...rest) {
        if (this.isLocked) {
            return;
        }
        spriteTexts.forEach((e) => {
            e.safeRemove();
        });
        spriteTexts = [];

        this.currentKey = key;
        this.currentRestParams = [...rest];
        const textArray = this.textToArray(data[key](...rest));

        links.forEach((link) => {
            link.scale.set(1);
            let indexOfLineSprite = 0;
            let lineXPosition = 0;
            const sprite = link.addChild(new Sprite());
            sprite.textSprites = [];
            spriteTexts.push(sprite);
            for (let i = 0; i < textArray.length; i++) {
                if (textArray[i].string !== '<n>') {
                    let sprText = null;

                    if (textArray[i].type === 'text') {
                        sprText = Static.writeNativeText(spriteTexts[indexOfLineSprite], textArray[i].string.replace('<n>', ''), this.font, this.xPosition, this.yPosition, styleForText);
                    } else {
                        sprText = Static.writeNativeText(spriteTexts[indexOfLineSprite], this.insertSpaceIntoDigits(textArray[i].string), this.font, this.xPosition, this.yPosition, styleForNumbers);
                    }

                    spriteTexts[indexOfLineSprite].textSprites.push(sprText);

                    sprText.position.set(lineXPosition, indexOfLineSprite * this.singleLineHeight + this.yPosition);

                    lineXPosition = sprText.x + sprText.width + 13;
                }

                if (textArray[i].string.includes('<n>')) {
                    const sprite = link.addChild(new Sprite());
                    sprite.textSprites = [];
                    spriteTexts.push(sprite);
                    indexOfLineSprite += 1;
                    lineXPosition = 0;
                }
            }
            link.position.y = this.yPosition - ((this.singleLineHeight * (spriteTexts.length - 1)) / 2);
        });
        spriteTexts.forEach((sprite) => {
            let mesureWidthLine = -13;

            sprite.textSprites.forEach((textSprite) => {
                mesureWidthLine += 13;
                mesureWidthLine += textSprite.width;
            });

            let newScale = textPanelMaxSize / mesureWidthLine;

            if (newScale < minScaleTextPanel) {
                // set new scale as min scale if newScale is less than minScaleTextPanel
                newScale = minScaleTextPanel;
            } else if (newScale > maxScaleTextPanel) {
                // set new scale as max scale if newScale is more than maxScaleTextPanel
                newScale = maxScaleTextPanel;
            }

            sprite.scale.set(newScale);

            sprite.position.x = this.xPosition - (mesureWidthLine * newScale) / 2;
        });
    }

    /**
   * @name textToArray
   * @param  {String} str message to convert
   * @description it used to convet text data to array separating numbers and text characters
   */
    static textToArray(str) {
        const textArray = [];
        if (str) {
            (function write(string) {
                const s = string.pop();
                const nextWord = string[string.length - 1];
                if (nextWord !== undefined && nextWord !== null && nextWord !== '' && isNaN(nextWord) && isNaN(s) && nextWord !== '<n>' && s !== '<n>') {
                    string.pop();
                    string.push(`${nextWord} ${s}`);
                    write(string);
                    return;
                }
                const a = {
                    string: s,
                    type: 'text',
                };

                if (!isNaN(s)) {
                    a.type = 'number';
                }

                textArray.push(a);

                if (string.length) {
                    write(string);
                }
            }((`${str}`).split(' ')));

            textArray.reverse();
        }
        return textArray;
    }

    static insertSpaceIntoDigits(str) {
        const numberWithSpace = [];
        for (let i = str.length - 1, j = 1; i >= 0; i--, j++) {
            numberWithSpace.unshift(str[i]);
            if (j % 3 === 0) {
                numberWithSpace.unshift(' ');
            }
        }
        return numberWithSpace.join('').trim();
    }


    static hide() {
        links.forEach(e => e.visible = false);
    }

    static show() {
        links.forEach(e => e.visible = true);
    }

    static lock() {
        this.isLocked = true;
    }

    static unlock() {
        this.isLocked = false;
    }
}

export default TextPanel;
